// src/config.ts

// 1) Define the type so TS knows graphqlUrl exists.
export type SiteConfig = {
  siteName: string;
  siteUrl: string;
  highlevelApiKey: string;        // move to env in production
  highlevelLocationId: string;
  highlevelProducts: {
    home: { monthly: string; annually: string; "bi-annually": string };
    design: { monthly: string; annually: string; "bi-annually": string };
    designPlus: { monthly: string; annually: string; "bi-annually": string };
  };
  graphqlUrl: string;             // <- required by your Apollo client
};

// 2) Implement the config. Add the missing comma before graphqlUrl.
export const SITE_CONFIG: SiteConfig = {
  siteName: "...",
  siteUrl: "https://homedesignguild.com",

  // ⚠️ Move this to an environment variable:
  // Using REACT_APP_ prefix for Create React App
  highlevelApiKey:
    process.env.REACT_APP_HIGHLEVEL_API_KEY ??
    "REPLACE_ME_AND_USE_ENVS",

  highlevelLocationId:
    process.env.REACT_APP_HIGHLEVEL_LOCATION_ID ?? "iatk4RAPtMOPMhPoQP7M",

  // Product IDs mapping
  // Using REACT_APP_* names for Create React App client-side usage.
  highlevelProducts: {
    home: {
      monthly: process.env.REACT_APP_HL_HOME_MONTHLY_ID || "",
      annually: process.env.REACT_APP_HL_HOME_ANNUAL_ID || "",
      "bi-annually":
        process.env.REACT_APP_HL_HOME_BIANNUAL_ID || "68b90b7678100b24b62b2b07",
    },
    design: {
      monthly: process.env.REACT_APP_HL_DESIGN_MONTHLY_ID || "",
      annually: process.env.REACT_APP_HL_DESIGN_ANNUAL_ID || "",
      "bi-annually": process.env.REACT_APP_HL_DESIGN_BIANNUAL_ID || "",
    },
    designPlus: {
      monthly: process.env.REACT_APP_HL_DESIGNPLUS_MONTHLY_ID || "",
      annually: process.env.REACT_APP_HL_DESIGNPLUS_ANNUAL_ID || "",
      "bi-annually": process.env.REACT_APP_HL_DESIGNPLUS_BIANNUAL_ID || "",
    },
  }, 

  // Apollo will read this. Use environment variable with fallback based on NODE_ENV
  graphqlUrl: process.env.REACT_APP_GRAPHQL_URL || 
    (process.env.NODE_ENV === 'production' 
      ? "https://hdg-api-service-485830218751.us-central1.run.app/graphql"
      : "http://localhost:8080/graphql"),
};
